export default "__VITE_ASSET__C4qawgdb__"